export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = "https://sd-api.codioticdemo.com/v1";
// export const BASE_URL = process.env.REACT_APP_BASE_URL_MAYANK;
// export const BASE_URL = process.env.REACT_APP_BASE_URL_PRAGYA;
// export const BASE_URL = "http://13.247.149.101:3002/v1"
export const FILE_MANAGER_URL = process.env.REACT_APP_FILE_MANAGER_URL;
export const CURRENCY = process.env.REACT_APP_BASE_CURRENCY;
